define([
  'react',
  'prop-types',
  'immutable',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, Component) => {
  const Html = Component({})(({
    onMouseEnter,
    onMouseLeave,
    onClickAction,
    html = '',
    style = Immutable.Map(),
    isPreview = false,
    closeOnClick = false,
  }) => {
    const containerRef = React.useRef(null);

    React.useEffect(() => {
      if (containerRef.current && html && html.trim()) {
        if (!isPreview) {
          setTimeout(() => {
            if (containerRef.current) {
              const scripts = containerRef.current.querySelectorAll('script');
              scripts.forEach((script) => {
                const newScript = document.createElement('script');

                // Handle external scripts (with src attribute)
                if (script.src) {
                  newScript.src = script.src;
                  // Copy all attributes from original script
                  Array.from(script.attributes).forEach((attr) => {
                    if (attr.name !== 'src') {
                      newScript.setAttribute(attr.name, attr.value);
                    }
                  });
                } else {
                  // Handle inline scripts
                  newScript.textContent = script.textContent;
                }

                document.head.appendChild(newScript);
              });

              // Add click event listeners to all elements in the custom HTML
              if (closeOnClick && onClickAction) {
                const allElements = containerRef.current.querySelectorAll('*');
                allElements.forEach((element) => {
                  element.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onClickAction('close', null, event);
                  });
                });
              }
            }
          }, 100);
        }
      }
    }, [html, isPreview, closeOnClick, onClickAction]);

    return (
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        role="button"
        tabIndex={0}
      >
        <div
          ref={containerRef}
          style={style.toJS()}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    );
  });

  Html.propTypes = {
    html: PropTypes.string,
    style: PropTypes.instanceOf(Immutable.Map),
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onClickAction: PropTypes.func,
    isPreview: PropTypes.bool,
    closeOnClick: PropTypes.bool,
  };

  return Html;
});
